var React = require('react');

function LongIconRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M19.1716 0.464562L22.3536 3.64654C22.5488 3.8418 22.5488 4.15839 22.3536 4.35365L19.1716 7.53563C18.9763 7.73089 18.6597 7.73089 18.4645 7.53563C18.2692 7.34037 18.2692 7.02378 18.4645 6.82852L20.7929 4.5001H0V3.5001H20.7929L18.4645 1.17167C18.2692 0.976407 18.2692 0.659824 18.4645 0.464562C18.6597 0.2693 18.9763 0.2693 19.1716 0.464562Z"}));
}

LongIconRight.defaultProps = {"width":"23","height":"8","viewBox":"0 0 23 8","fill":"none"};

module.exports = LongIconRight;

LongIconRight.default = LongIconRight;
